// extracted by mini-css-extract-plugin
export default {"roundButton":"roundButton__gvPsK","btnWrapper":"btnWrapper__FXEYl","loader":"loader__KOR5A","loaderWrapper":"loaderWrapper__dhFq2"};